import { mapState } from 'vuex';
import ReviewResourceView from './ReviewResourceView';

export default {
  mixins: [ReviewResourceView],
  data() {
    return { isAppendingPage: false, isPrependingPage: false };
  },
  computed: {
    ...mapState('window', ['windowService']),
    paginationProps() {
      return {
        pagy: this.pagy,
        disabled: this.isAppendingPage || this.isPrependingPage
      };
    },
    paginationEvents() {
      return {
        click: this.clickPage,
        append: this.appendPage,
        prepend: this.prependPage
      };
    }
  },
  methods: {
    clickPage(page) {
      this.searchResource({ page });
    },
    appendPage({ page, offset }) {
      this.isAppendingPage = true;
      const params = {
        ...this.defaultResourceParams,
        ...this.resourceParams,
        page,
        ...(this.defaultResourceParams?.fields?.includes('media_page')
          ? { media_page: page }
          : {})
      };
      return this.fetchReviews({ params, append: true }).finally(() => {
        this.isAppendingPage = false;
        if (offset) this.windowService.scrollTo(offset);
      });
    },
    prependPage(page) {
      this.isPrependingPage = true;
      const params = {
        ...this.defaultResourceParams,
        ...this.resourceParams,
        page,
        ...(this.defaultResourceParams?.fields?.includes('media_page')
          ? { media_page: page }
          : {})
      };
      return this.fetchReviews({ params, prepend: true }).finally(
        () => (this.isPrependingPage = false)
      );
    }
  }
};
